import { TimelineLite } from 'gsap';

import { BaseComponentDrawer } from '../../../core/abstraction/BaseComponentDrawer';

import {
  crystalTypes,
  movingLightEffectResourceNames,
} from '../../../core/gameConstants';
import {
  FREE_SPINS_DATA_STATE,
  USER_DATA,
} from '../../../stateManagment/gameState';
import { mobileBackgroundRssNames } from '../../../core/mobileResourceNames';
import { getTranslation, translationKeys } from '../../../core/translation/translation';
import { gameMobileConfig } from '../../../core/configs';
import { FONT_LATO_NAME } from '../../../core/constats';
import { iframeService } from '../../../services/IframeService';
import { soundService } from '../../../services/helperService/PixiSoundService';
import {gameDrawer} from "../../../game/GameDrawer";

export class BaseBackgroundDrawer extends BaseComponentDrawer {
  __calcStartAnimation({ wheel }) {
    if (!this.startPosition) {
      const { x, y } = wheel.children[0].position;
      this.startPosition = { x, y };
    }
  }

  __createStar(duration = .2) {
    const star = this.createSprite(this.resources[movingLightEffectResourceNames.star]);
    star.anchor.set(.5);
    star.scale.set(.4);
    star.alpha = 0;

    const startAnimation = () => {
      new TimelineLite()
        .to(star, { duration, pixi: { scale: 1 }, alpha: .5 })
        .to(star, { duration, pixi: { scale: .5 }, alpha: .9 })
        .to(star, { duration: .1, pixi: { scale: .1 }, alpha: 0 });
    };

    return [star, startAnimation];
  }

  getUserIdAndDeposit({ w = 160, h = 80, icon, m = 3, freeBetIcon } = {}) {
    const nativeW = w;
    w = freeBetIcon ? w + freeBetIcon.width + m : w;
    const container = this.createContainer('Deposit');

    const roundedRect = this.createGraphics()
      .beginFill(0x000000)
      .drawRoundedRect(0, 0, w + 2 * m, h + 2 * m, 26)
      .endFill();

    const depositRect = this.createGraphics()
      .beginFill(0x37a718)
      .drawRoundedRect(m, h / 2 - 5 + m, nativeW, h / 2 + 5, h / 2)
      .endFill();
    const radius = (h / 2 + 5) / 2;

    this.setupButtonMode(depositRect);
    this.registerClick(depositRect, () => {
      soundService.playSingleClick();
      iframeService.openDeposit();
    });

    const plusContainer = this.createGraphics()
      .beginFill(0x38c313)
      .drawCircle(radius + m, h / 2 - 5 + m + radius, radius)
      .endFill();
    roundedRect.alpha = .5;
    const depositTitle = new this.PIXI.Text(`${getTranslation(translationKeys.DEPOSIT)}`, {
      fill: 0xFFFFFF,
      fontSize: 20,
      align: 'center',
    });
    depositTitle.anchor.set(.5);

    this.setPosition(depositTitle, { x: nativeW / 2 + radius, y: (h + depositTitle.height) / 2 + 5 + m });
    const userIdTitle = new this.PIXI.Text('ID', {
      fill: 0xEEEEEE,
      fontSize: 20,
      align: 'center',
    });
    userIdTitle.anchor.set(.5);
    this.setPosition(userIdTitle, { x: nativeW / 2, y: userIdTitle.height / 2 + 5 + m });
    this.addSubscriber(USER_DATA.subscribe((data) => {
      if (data && data.id) {
        userIdTitle.text = `ID ${data.id}`;
      }
    }, true));
    if (icon) {
      icon.anchor.set(.5);
      icon.scale.set(.8);
      this.setPosition(icon, { x: radius + m, y: h / 2 - 5 + radius + m });
      plusContainer.addChild(icon);
    }

    container.addChild(
      roundedRect,
      depositRect,
      plusContainer,
      userIdTitle,
      depositTitle,
    );
    container.size = container.width;

    if (freeBetIcon) {
      const countRect = this.createGraphics()
        .beginFill(0xf3bd0d)
        .drawRoundedRect(
          nativeW + freeBetIcon.width / 2 + 10, -5, 48, 18, 9,
        )
        .endFill();
      const countTitle = new this.PIXI.Text('', {
        fontFamily: FONT_LATO_NAME,
        fontSize: 14,
        fontWeight: 600,
        fill: 0x010101,
      });
      freeBetIcon.anchor.set(.5);
      countTitle.anchor.set(.5);
      countRect.addChild(countTitle);
      this.setPosition(freeBetIcon, { x: nativeW + freeBetIcon.width / 2 + 2 * m, y: h / 2 + m });
      this.setPosition(countTitle, { x: nativeW + freeBetIcon.width / 2 + 35, y: 3 });
      container.addChild(
        freeBetIcon,
        countRect,
      );
      container.size = container.width - 20;
      this.addSubscriber(FREE_SPINS_DATA_STATE.subscribe(({ length }) => {
        if (length) {
          countTitle.text = `x${length}`;
        } else {
          countRect.alpha = 0;
        }
      }, true));
    }

    return container;
  }

  getLastResultUi({
    scale = 1.2,
    crystalW = 36,
    crystalScale = .18,
    parentWidth = gameMobileConfig.config.width,
    fullRectWidth = 278,
    lastResultObserver,
    calcFirstElementPosition = () => {
    },
  } = {}) {
    const container = this.createContainer('LAST_RESULT');
    const resultContainer = this.createContainer('RESULT_CONTAINER');
    const lastResultsOpacity = this.createGraphics()
      .drawRect(
        0,
        0,
        210,
        45,
      )
      .endFill();
    const lastResultsOpacityImage = this.createSprite(this.resources[mobileBackgroundRssNames.lastResultsOpacity]);
    lastResultsOpacityImage.scale.set(scale);
    lastResultsOpacity.addChild(lastResultsOpacityImage);
    const space = (parentWidth - lastResultsOpacity.width) / 2;
    this.setPosition(lastResultsOpacityImage, { x: space });
    const lastResultText = new this.PIXI.Text(`${getTranslation(translationKeys.LAST_RESULTS)}:`, {
      fontSize: 20,
      fill: 0xFFFFFF,
      align: 'right',
      fontFamily: FONT_LATO_NAME,
      fontWeight: 900,
    });
    this.setPosition(lastResultText, { x: space + 40, y: 8 });

    const rect = this.createGraphics()
      .drawRect(
        0,
        0,
        210,
        45,
      )
      .endFill();
    this.addSubscriber(
      lastResultObserver.subscribe((crystals, { prev }) => {
        rect.children = [];
        crystals.forEach((crystalName, index) => {
          if (!this.resources[crystalTypes[crystalName]]) {
            return;
          }
          const container = this.createContainer('crystalName');
          const [star, starAnimation] = this.__createStar();
          const crystal = this.createSprite(this.resources[crystalTypes[crystalName]]);
          crystal.anchor.set(.5);
          this.setPosition(container, { x: 10 + index * (crystalW - 14), y: 17 });
          crystal.scale.set(crystalScale);
          if (!index && prev) {
            this.lastCrystal = {
              crystal,
              starAnimation,
            };
            this.lastCrystal.crystal.alpha = 0;
          }
          container.addChild(
            star,
            crystal,
          );
          rect.addChild(container);
        });
      }, true),
    );

    this.setPosition(rect, { x: space + fullRectWidth - 90, y: 4 });
    calcFirstElementPosition({ x: space + fullRectWidth - 80, y: 21 });

    resultContainer.addChild(rect);
    container.addChild(
      lastResultsOpacity,
      lastResultText,
      resultContainer,
    );
    return container;
  }
}
